import React from 'react';
import { VideoPlayer } from '../../../../components/VideoPlayer';
import {
  Section,
  ContentContainer,
  HeaderContainer,
  SectionHeader,
  SectionSubHeader,
  ValuePropGrid,
  ValuePropContainer,
  ValuePropHeader,
  ValuePropParagraph,
} from './styles';

export function ValueProposition() {
  return (
    <Section>
      <ContentContainer>
        <HeaderContainer>
          <SectionHeader>
            The biggest podcasting platform in the world
          </SectionHeader>
          <SectionSubHeader>
            Simply create, record, and watch your audience grow.
          </SectionSubHeader>
        </HeaderContainer>
        <VideoPlayer />
        <ValuePropGrid>
          <ValueProp
            header="Be heard everywhere"
            paragraph="We’ll distribute your show to Spotify and other listening apps."
          />
          <ValueProp
            header="Free and unlimited hosting"
            paragraph="No storage limits, no trial period—no catch."
          />
          <ValueProp
            header="No equipment necessary"
            paragraph="Our tools help you effortlessly record and edit."
          />
          <ValueProp
            header="Get paid to podcast"
            paragraph="A new way to make money from your content."
          />
          <ValueProp
            header="Straightforward analytics"
            paragraph="Gain insights on your listeners and how to grow your audience."
          />
        </ValuePropGrid>
      </ContentContainer>
    </Section>
  );
}

function ValueProp({
  header,
  paragraph,
}: {
  header: string;
  paragraph: string;
}) {
  return (
    <ValuePropContainer>
      <ValuePropHeader>{header}</ValuePropHeader>
      <ValuePropParagraph>{paragraph}</ValuePropParagraph>
    </ValuePropContainer>
  );
}
